// 原始文件：https://github.com/kinddde/js-export-excel/blob/master/src/js-export-excel.js
// 对原始文件做了 tree shaking 优化，移除了一些 team 里面不用的逻辑

import { SSF, utils, writeXLSX } from '@proxima/xlsx/xlsx.mjs';
import { saveAs } from 'file-saver';

/**
 * Created by kin on 2017/5/18.
 *
 * json导出excel
 * mail：cuikangjie_90h@126.com
 */
const changeData = function (data, filter) {
  const sj = data;
  const f = filter;
  let re = [];
  Array.isArray(data)
    ? (function () {
        //对象
        f
          ? (function () {
              //存在过滤
              sj.forEach(function (obj) {
                const one = [];
                filter.forEach(function (no) {
                  one.push(obj[no]);
                });
                re.push(one);
              });
            })()
          : (function () {
              //不存在过滤
              sj.forEach(function (obj) {
                const col = Object.keys(obj);
                const one = [];
                col.forEach(function (no) {
                  one.push(obj[no]);
                });
                re.push(one);
              });
            })();
      })()
    : (function () {
        re = sj;
      })();
  return re;
};

// 转换数据
const sheetChangeData = function (data) {
  const ws = {};
  const range = {
    s: {
      c: 10000000,
      r: 10000000,
    },
    e: {
      c: 0,
      r: 0,
    },
  };
  for (let R = 0; R < data.length; ++R) {
    for (let C = 0; C < data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      const cell = {
        v: data[R][C],
      } as Record<string, any>;

      if (cell.v == null) continue;

      const cell_ref = utils.encode_cell({
        c: C,
        r: R,
      });

      if (typeof cell.v === 'number') cell.t = 'n';
      else if (typeof cell.v === 'boolean') cell.t = 'b';
      else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = SSF._table[14];
        cell.v = datenum(cell.v);
      } else if (/^hyperlink:/.test(cell.v)) {
        cell.l = {
          Target: cell.v.replace(/^hyperlink:/, ''),
        };
        cell.v = cell.v.replace(/^hyperlink:/, '');
      } else cell.t = 's';
      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = utils.encode_range(range);
  return ws;
};

const s2ab = function (s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};
const datenum = function (v) {
  const epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30)).getTime()) / (24 * 60 * 60 * 1000);
};

const exportExcel = function (options) {
  const _options = {
    fileName: options.fileName || 'download',
    data: options.data,
  };

  const instance = {
    saveExcel: function () {
      const wb = {
        SheetNames: [],
        Sheets: {},
      };

      const data = _options.data;

      const sheetHeader = data.sheetHeader || null;
      let sheetData = data.sheetData;
      const sheetName = data.sheetName || 'sheet1';
      const sheetFilter = data.sheetFilter || null;

      sheetData = changeData(sheetData, sheetFilter);

      if (sheetHeader) {
        sheetData.unshift(sheetHeader);
      }

      const ws = sheetChangeData(sheetData);

      ws['!merges'] = [];

      wb.SheetNames.push(sheetName);
      wb.Sheets[sheetName] = ws;

      const wbout = writeXLSX(wb, {
        bookSST: false,
        type: 'binary',
      });
      saveAs(
        new Blob([s2ab(wbout)], {
          type: 'application/octet-stream',
        }),
        _options.fileName + '.xlsx',
      );
    },
  };

  return instance;
};

export default exportExcel;
